// extracted by mini-css-extract-plugin
export default {"user-avatar-container":"style_user-avatar-container__4xqU1","user-name":"style_user-name__TKozP","forno-avatar-wrapper":"style_forno-avatar-wrapper__eJ20W"};